exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".X3pyp8I3mMWxtVOYOLwuR{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex}._2dvFCr19_ts3BEm_OTFYKc{-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}html[dir=ltr] .WrKIJCDG-6aajFEEvZaZf{margin-left:0}html[dir=rtl] .WrKIJCDG-6aajFEEvZaZf{margin-right:0}", ""]);
// Exports
exports.locals = {
	"toolTipHost": "X3pyp8I3mMWxtVOYOLwuR",
	"textDescription": "_2dvFCr19_ts3BEm_OTFYKc",
	"label": "WrKIJCDG-6aajFEEvZaZf"
};